<template>
  <div>
    <v-row v-if="!recap" class="mt-5">
      <v-col cols="6" lg="4" order="1"
        ><v-btn
          block
          color="backgroundShade"
          prepend-icon="mdi-arrow-left"
          @click="stepBack"
          :loading="$store.state.loading.loadingState"
          >Zurück</v-btn
        ></v-col
      ><v-col
        cols="12"
        lg="4"
        :order="$vuetify.display.mdAndDown ? 4 : 2"
        :class="{ 'my-0 py-0': $vuetify.display.mdAndDown }"
        ><v-btn
          color="backgroundShade"
          block
          :size="$vuetify.display.mdAndDown ? 'small' : 'default'"
          @click="saveStepData"
          :loading="$store.state.loading.loadingState"
          >Zwischenspeichern</v-btn
        ></v-col
      ><v-col cols="6" lg="4" order="3"
        ><v-btn
          block
          append-icon="mdi-arrow-right"
          color="primary"
          :loading="$store.state.loading.loadingState"
          @click="checkStep"
          >Weiter</v-btn
        ></v-col
      ></v-row
    >
  </div>
</template>

<script>
import { nextStep, saveData, getBack } from "@/services/onboarding.service";

export default {
  name: "OnboardingNavigation",
  emits: ["next"],
  props: {
    form: Object,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    stepBack() {
      getBack();
    },
    async saveStepData() {
      this.$store.dispatch("loading/toggle", true);
      await saveData(this.$store.state.processes.onboarding.data);
      this.$store.dispatch("loading/toggle", false);
    },
    back() {
      //TODO Implement back frontend
    },
    checkStep() {
      //TODO Go to Server and check step 1 if good increase activeStep
      this.$store.dispatch("loading/toggle", true);
      nextStep(this.form).then(() => {
        window.scrollTo(0, 0);
        this.$emit("next");
      });
    },
  },
};
</script>
